import type { ReactNode } from "react";
import { useSession } from "@/hooks/use-session";
import NotFound from "@/pages/not-found";

export function AdminGuard({ children }: { children: ReactNode }) {
  const { data } = useSession();
  if (!data?.isAdmin) return <NotFound />;
  return <>{children}</>;
}
